import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> into <head> and cleans up on unmount.
 * Pass any schema-valid object (or array of objects) as `data`.
 */
export function JsonLd({ data }: { data: Record<string, unknown> | Record<string, unknown>[] }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [data]);

  return null;
}
